export interface PlanillaPartidoEnVivoJSON {
  ppev_id: string;
  ppev_ppid: number;
  ppev_timer: string;
  ppev_goles_local: number;
  ppev_goles_visitante: number;
  ppev_cant_tarj_amarilla_local: number;
  ppev_cant_tarj_amarilla_visitante: number;
  ppev_cant_2_minutos_local: number;
  ppev_cant_2_minutos_visitante: number;
  ppev_cant_tarj_roja_local: number;
  ppev_cant_tarj_roja_visitante: number;
  ppev_cant_tarj_azul_local: number;
  ppev_cant_tarj_azul_visitante: number;
  ppev_tiempo_detenido: boolean;
}

export class PlanillaPartidoEnVivo {
  protected constructor(
    private id: string,
    private ppId: number,
    private timer: string,
    private golesLocal: number,
    private golesVisitante: number,
    private cantAmarillasLocal: number,
    private cantAmarillasVisitante: number,
    private cantDosMinLocal: number,
    private cantDosMinVisitante: number,
    private cantRojasLocal: number,
    private cantRojasVisitante: number,
    private cantAzulesLocal: number,
    private cantAzulesVisitante: number,
    private tiempoDetenido: boolean
  ) {}

  static createFrom(
    id: string,
    ppId: number,
    timer: string,
    golesLocal: number,
    golesVisitante: number,
    cantAmarillasLocal: number,
    cantAmarillasVisitante: number,
    cantDosMinLocal: number,
    cantDosMinVisitante: number,
    cantRojasLocal: number,
    cantRojasVisitante: number,
    cantAzulesLocal: number,
    cantAzulesVisitante: number,
    tiempoDetenido: boolean
  ) {
    return new this(
      id,
      ppId,
      timer,
      golesLocal,
      golesVisitante,
      cantAmarillasLocal,
      cantAmarillasVisitante,
      cantDosMinLocal,
      cantDosMinVisitante,
      cantRojasLocal,
      cantRojasVisitante,
      cantAzulesLocal,
      cantAzulesVisitante,
      tiempoDetenido
    );
  }

  static fromJSON(entity: PlanillaPartidoEnVivoJSON) {
    return PlanillaPartidoEnVivo.createFrom(
      entity.ppev_id,
      entity.ppev_ppid,
      entity.ppev_timer,
      entity.ppev_goles_local,
      entity.ppev_goles_visitante,
      entity.ppev_cant_tarj_amarilla_local,
      entity.ppev_cant_tarj_amarilla_visitante,
      entity.ppev_cant_2_minutos_local,
      entity.ppev_cant_2_minutos_visitante,
      entity.ppev_cant_tarj_roja_local,
      entity.ppev_cant_tarj_roja_visitante,
      entity.ppev_cant_tarj_azul_local,
      entity.ppev_cant_tarj_azul_visitante,
      entity.ppev_tiempo_detenido
    );
  }

  toJSON(): PlanillaPartidoEnVivoJSON {
    return {
      ppev_id: this.id,
      ppev_ppid: this.ppId,
      ppev_timer: this.timer,
      ppev_goles_local: this.golesLocal,
      ppev_goles_visitante: this.golesVisitante,
      ppev_cant_tarj_amarilla_local: this.cantAmarillasLocal,
      ppev_cant_tarj_amarilla_visitante: this.cantAmarillasVisitante,
      ppev_cant_2_minutos_local: this.cantDosMinLocal,
      ppev_cant_2_minutos_visitante: this.cantDosMinVisitante,
      ppev_cant_tarj_roja_local: this.cantRojasLocal,
      ppev_cant_tarj_roja_visitante: this.cantRojasVisitante,
      ppev_cant_tarj_azul_local: this.cantAzulesLocal,
      ppev_cant_tarj_azul_visitante: this.cantAzulesVisitante,
      ppev_tiempo_detenido: this.tiempoDetenido,
    };
  }
}
